module.exports = __webpack_public_path__ + "static/media/threeminfrenzy.e1eb152a.jpg";